import AbstractConfig from "../../../core/config/AbstractConfig";

export default class SoundConfig extends AbstractConfig {
    constructor() {
        super();
    }

    getVolume(id) {
        return this.getValue('volume.' + id);
    }

    getSoundId(imageId) {
        const soundId = this.getValue('soundPerLocation.' + imageId);
        if(!soundId) {
            console.log(`[SoundConfig] No audio configured for location ${imageId}`);
            return null;
        }
        console.log(`[SoundConfig] Location ${imageId} got audio: '${soundId}' with volume: '${this.getVolume(soundId)}'`);
        return soundId;
    }
}